import React, { useEffect, useState, useCallback } from "react";
import "./App.css";

export default function App() {
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchQuote = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      // Primary: DummyJSON
      const res = await fetch("https://dummyjson.com/quotes/random");
      if (!res.ok) throw new Error(`DummyJSON HTTP ${res.status}`);
      const data = await res.json(); // { id, quote, author }
      if (!data.quote) throw new Error("DummyJSON returned no quote");
      setQuote(data.quote);
      setAuthor(data.author || "Unknown");
    } catch (e1) {
      try {
        // Fallback: Type.fit
        const r2 = await fetch("https://type.fit/api/quotes");
        if (!r2.ok) throw new Error(`Type.fit HTTP ${r2.status}`);
        const arr = await r2.json(); // [ { text, author }, ... ]
        if (!Array.isArray(arr) || !arr.length)
          throw new Error("Type.fit returned empty list");
        const q = arr[Math.floor(Math.random() * arr.length)] || {};
        setQuote(q.text || "");
        setAuthor(q.author || "Unknown");
      } catch (e2) {
        setQuote("");
        setAuthor("");
        setError(`Couldn’t load a quote (${e1.message}; ${e2.message}).`);
      }
    } finally {
      setLoading(false);
    }
  }, []); // stable reference -> safe to put in effect deps

  useEffect(() => {
    fetchQuote(); // runs once on mount
  }, [fetchQuote]);

  return (
    <div className="App">
      <h1>Random Quote Generator</h1>

      <div className="quote-box">
        {loading ? (
          <p className="quote-text">Loading…</p>
        ) : error ? (
          <p className="quote-text">{error}</p>
        ) : quote ? (
          <>
            <p className="quote-text">“{quote}”</p>
            <p className="quote-author">— {author}</p>
          </>
        ) : (
          <p className="quote-text">Click the button for a quote</p>
        )}
      </div>

      <button className="new-quote-button" onClick={fetchQuote} disabled={loading}>
        {loading ? "Fetching…" : "New Quote"}
      </button>
    </div>
  );
}
